export class ConferencePageController {
    /*@ngInject*/
    constructor($timeout, utilityService) {
        this.$timeout = $timeout;
        this.utilityService = utilityService;
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
        this.isLoaded = false;
        this.candidateId = this.$stateParams.c;
        this.jobId = this.$stateParams.j;
        this.jobMatchId = this.$stateParams.jm;
        this.scheduleId = this.$stateParams.sh;
        this.type = "u";
        // this.type = this.$stateParams.t;
        this.mode = this.$stateParams.mode;
        this.workflowStep = this.$stateParams.ws;
        this.utilityService.toggleHeaderNavDisplay(false);
        this.$timeout(() => {
            this.isLoaded = true;
        }, 4000);
    }
}
ConferencePageController.$inject = ['$timeout', 'utilityService'];
import * as TEMPLATE from 'raw-loader!./conference-page.html';
export const ConferencePageComponent = {
    selector: 'conferencePage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/conference/conference-page.html',
        controller: ConferencePageController
    }
};
//# sourceMappingURL=conference-page.component.js.map